<template>
  <div>
    <v-dialog v-model="dialog" max-width="450px">
      <v-card
        :loading="loading"
        class="mx-auto elevation-1"
        width="450px">

        <v-img 
          class="text-white d-flex align-start"
          :src="require('@/assets/praia_ondas.jpg')"
          height="200"
          cover>
          <v-card-title class="d-flex justify-end w-100">
            <img style="height: 50px;" :src="require('@/assets/logo.png')" alt="smartsurf_logo" />
          </v-card-title>
        </v-img>

        <v-card-title>{{ $t("messages.Register") }}</v-card-title>

        <v-card-text>
          <v-form autocomplete="off">
            <v-text-field
              v-model="newUser.email"
              :label="$t('messages.email')"
              name="email_reg_field"
              prepend-inner-icon="mdi-account"
              type="text"
              autocomplete="chrome-off"
              variant="outlined"
            ></v-text-field>
            <v-text-field
              v-model="newUser.password"
              id="password"
              :label="$t('messages.password')"
              name="password_reg_field"
              prepend-inner-icon="mdi-lock"
              type="password"
              autocomplete="new-password"
              variant="outlined"
            ></v-text-field>
            <v-text-field
              v-model="confirmPassword"
              id="confirm-password"
              :label="$t('messages.confirm_password')"
              name="confirm_password_reg_field"
              prepend-inner-icon="mdi-lock-check"
              type="password"
              autocomplete="new-password"
              variant="outlined"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-btn 
            variant="outlined" 
            @click="dialog = false"
            prepend-icon="mdi-close"
          >
            {{ $t("messages.close") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn 
            color="primary" 
            variant="elevated"
            @click="signup()" 
            :disabled="!newUser.email || !newUser.password || !confirmPassword"
            prepend-icon="mdi-account-plus"
          >
            {{ $t("messages.Register") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import httpClient from '../../api/httpClient'

export default {
  inject: ['bus'],
  data () {
    return {
      dialog: false,
      loading: false,
      newUser: {},
      confirmPassword: '',
    }
  },
  mounted () {
    this.bus.on("signupDialog", () => this.dialog = true)
  },
  methods: {
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    signup() {
      if (!this.validateEmail(this.newUser.email)) {
        this.bus.emit('modernSnackBarMsg', {error: true, msg: this.$t('messages.email_invalid_signup')})
        return
      }

      if (this.newUser.password !== this.confirmPassword) {
        this.bus.emit('modernSnackBarMsg', {error: true, msg: this.$t('messages.passwords_do_not_match')})
        return
      }

      this.loading = true
      httpClient
        .post('/oauth/api/v1/register', this.newUser)
        .then(r => {
          this.loading = false
          if (!r.data.error) {
            this.dialog = false
            this.$router.push('/registration-success')
          } else {
            // Handle specific errors or generic error message
            this.bus.emit('modernSnackBarMsg', {error: true, msg: this.$t('messages.error_registering')})
          }
        })
        .catch(e => {
          this.loading = false
          console.error(e.message)
          this.bus.emit('modernSnackBarMsg', {error: true, msg: this.$t('messages.error_registering')})
        })
    }
  }
}
</script>

<style scoped>
@keyframes blink {
  50% { opacity: 1; }
  70% { opacity: 0.8; }
  100% { opacity: 1; }
}

.blinking-element {
  animation: blink 2s infinite;
}
</style>